import Vue from "vue";
import Template from "./components/Template";
import Empty from "./components/Empty";

Vue.component("layout", Template);
Vue.component("Empty", Empty);
